import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
import { useTranslation } from '../lib/i18n';
export function Datenschutz() {
  const {
    t
  } = useTranslation();
  return <HelmetProvider data-id="element-157">
      <div className="min-h-screen bg-background text-text-primary font-sans flex flex-col" data-id="element-158">
        <Helmet data-id="element-159">
          <title data-id="element-160">Datenschutzerklärung | Caro Loesel</title>
          <meta name="robots" content="noindex, nofollow" data-id="element-161" />
        </Helmet>

        <main className="flex-grow container mx-auto px-4 py-12 md:py-20 max-w-3xl" data-id="element-162">
          <Link to="/" className="inline-flex items-center text-hotpink hover:text-hotpink/80 transition-colors mb-8 font-medium" data-id="element-163">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-164" />
            {t.legal.backToHome}
          </Link>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-8" data-id="element-165">
            Datenschutzerklärung
          </h1>

          <div className="space-y-8 text-text-secondary leading-relaxed" data-id="element-166">
            <section data-id="element-167">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-168">
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-169">
                Allgemeine Hinweise
              </h3>
              <p className="mb-4" data-id="element-170">
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche
                Informationen zum Thema Datenschutz entnehmen Sie unserer unter
                diesem Text aufgeführten Datenschutzerklärung.
              </p>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-171">
                Datenerfassung auf dieser Website
              </h3>
              <p data-id="element-172">
                <strong data-id="element-173">
                  Wer ist verantwortlich für die Datenerfassung auf dieser
                  Website?
                </strong>
                <br data-id="element-174" />
                Die Datenverarbeitung auf dieser Website erfolgt durch den
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum
                dieser Website entnehmen.
              </p>
            </section>

            <section data-id="element-175">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-176">
                2. Hosting und Content Delivery Networks (CDN)
              </h2>
              <p data-id="element-177">
                Wir hosten die Inhalte unserer Website bei einem externen
                Anbieter. Die personenbezogenen Daten, die auf dieser Website
                erfasst werden, werden auf den Servern des Hosters gespeichert.
                Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen,
                Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten,
                Namen, Webseitenzugriffe und sonstige Daten, die über eine
                Website generiert werden, handeln.
              </p>
            </section>

            <section data-id="element-178">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-179">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-180">
                Datenschutz
              </h3>
              <p className="mb-4" data-id="element-181">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                vertraulich und entsprechend der gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-182">
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="mb-4" data-id="element-183">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser
                Website ist:
                <br data-id="element-184" />
                <br data-id="element-185" />
                EXXOTIC Management UG
                <br data-id="element-186" />
                Äußere Bayreuther Str. 59
                <br data-id="element-187" />
                90409 Nürnberg
                <br data-id="element-188" />
                Deutschland
                <br data-id="element-189" />
                <br data-id="element-190" />
                E-Mail: info@exxotic-management.com
              </p>
            </section>

            <section data-id="element-191">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-192">
                4. Datenerfassung auf dieser Website
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-193">Cookies</h3>
              <p className="mb-4" data-id="element-194">
                Unsere Internetseiten verwenden so genannte „Cookies“. Cookies
                sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                Schaden an. Sie werden entweder vorübergehend für die Dauer
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden
                nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies
                bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst
                löschen oder eine automatische Löschung durch Ihren Webbrowser
                erfolgt.
              </p>

              <h4 className="font-semibold text-text-primary mt-6 mb-2" data-id="element-195">
                Verwendete Cookies auf dieser Website
              </h4>

              <div className="mb-6 space-y-4" data-id="element-196">
                <div data-id="element-197">
                  <h5 className="font-medium text-text-primary" data-id="element-198">
                    1. Notwendige Cookies
                  </h5>
                  <ul className="list-disc pl-5 mt-1 space-y-1 text-sm" data-id="element-199">
                    <li data-id="element-200">
                      <strong data-id="element-201">cookie_consent:</strong> Speichert Ihre
                      Cookie-Einstellungen. Ablauf: 1 Jahr.
                    </li>
                    <li data-id="element-202">
                      <strong data-id="element-203">lang:</strong> Speichert Ihre Spracheinstellung.
                      Ablauf: Sitzung (localStorage).
                    </li>
                  </ul>
                </div>

                <div data-id="element-204">
                  <h5 className="font-medium text-text-primary" data-id="element-205">
                    2. Analyse-Cookies (nur mit Einwilligung)
                  </h5>
                  <ul className="list-disc pl-5 mt-1 space-y-1 text-sm" data-id="element-206">
                    <li data-id="element-207">
                      <strong data-id="element-208">_ga, _ga_*:</strong> Google Analytics Cookies zur
                      anonymen Erfassung von Nutzungsstatistiken. Ablauf: 2
                      Jahre.
                    </li>
                  </ul>
                </div>

                <div data-id="element-209">
                  <h5 className="font-medium text-text-primary" data-id="element-210">
                    3. Marketing-Cookies (nur mit Einwilligung)
                  </h5>
                  <ul className="list-disc pl-5 mt-1 space-y-1 text-sm" data-id="element-211">
                    <li data-id="element-212">
                      Cookies von Drittanbietern zur Anzeige personalisierter
                      Inhalte.
                    </li>
                  </ul>
                </div>
              </div>

              <p className="mb-4" data-id="element-213">
                Sie können Ihre Cookie-Einstellungen jederzeit über den
                Cookie-Banner am unteren Bildschirmrand anpassen. Ihre
                Einwilligung können Sie jederzeit mit Wirkung für die Zukunft
                widerrufen.
              </p>

              <p className="mb-4" data-id="element-214">
                <strong data-id="element-215">Rechtsgrundlage für die Verarbeitung:</strong> Für
                notwendige Cookies ist die Rechtsgrundlage Art. 6 Abs. 1 lit. f
                DSGVO (berechtigtes Interesse). Für Analyse- und
                Marketing-Cookies ist die Rechtsgrundlage Art. 6 Abs. 1 lit. a
                DSGVO (Einwilligung).
              </p>

              <h3 className="font-semibold text-text-primary mb-2 mt-6" data-id="element-216">
                Server-Log-Dateien
              </h3>
              <p data-id="element-217">
                Der Provider der Seiten erhebt und speichert automatisch
                Informationen in so genannten Server-Log-Dateien, die Ihr
                Browser automatisch an uns übermittelt. Dies sind:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-218">
                <li data-id="element-219">Browsertyp und Browserversion</li>
                <li data-id="element-220">Verwendetes Betriebssystem</li>
                <li data-id="element-221">Referrer URL</li>
                <li data-id="element-222">Hostname des zugreifenden Rechners</li>
                <li data-id="element-223">Uhrzeit der Serveranfrage</li>
                <li data-id="element-224">IP-Adresse</li>
              </ul>
            </section>

            <section data-id="element-225">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-226">
                5. Analyse-Tools und Werbung
              </h2>
              <p data-id="element-227">
                Soweit Sie Ihre Einwilligung erklärt haben, wird auf dieser
                Website Google Analytics eingesetzt, ein Webanalysedienst der
                Google LLC. Zuständiger Dienstanbieter in der EU ist die Google
                Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland
                („Google“).
              </p>
            </section>

            <section data-id="element-228">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-229">
                6. Plugins und Tools
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-230">
                Google Web Fonts
              </h3>
              <p data-id="element-231">
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
                so genannte Web Fonts, die von Google bereitgestellt werden.
                Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web
                Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
                anzuzeigen.
              </p>
            </section>
          </div>
        </main>

        <Footer data-id="element-232" />
      </div>
    </HelmetProvider>;
}